/**
 * Plays the alarm sound sample based on the sound type. Designed to be used in stats alarming settings.
 *
 * @param soundType The sound type.
 */
export const playAlarmSoundSample = (soundType: number): void => {
    const windowRef = window as Window & typeof globalThis & { m_pRptPortal: CRptPortal }
    const mediaFolder = windowRef.m_pRptPortal.getMediaFolder()

    if (mediaFolder) {
        // eslint-disable-next-line
        const mediaFileName = com.Akixi.Alarming.pAlarmSounds[soundType - 1].sFilename
        if (mediaFileName) {
            // Play the audio via Audio API.
            const mediaPath = `${mediaFolder}${mediaFileName}`
            const audioPlayer = new Audio()
            audioPlayer.setAttribute('src', mediaPath)
            audioPlayer.load()
            audioPlayer.play()
        }
    }
}
